(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cosori-air-fryer-compare"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const selects = Array.from(root.querySelectorAll('[data-compare-select]'));
      const templateElements = Array.from(root.querySelectorAll('template[data-compare-product]'));
      const templates = new Map(
        templateElements.map((template) => [
          template.dataset.compareProduct,
          template
        ])
      );
      const productIdsByHandle = new Map(
        templateElements.map((template) => [
          template.dataset.productHandle,
          template.dataset.compareProduct
        ])
      );
      const productHandlesById = new Map(
        templateElements.map((template) => [
          template.dataset.compareProduct,
          template.dataset.productHandle
        ])
      );
      const status = root.querySelector('[data-compare-status]');
      const specificationCache = new Map();
      const recentStorageKey = 'cosori_recent_air_fryers_v1';
      const specificationLabels = new Map([
        ['power supply', 'power_supply'],
        ['rated power', 'rated_power'],
        ['capacity', 'capacity'],
        ['temperature range', 'temperature_range'],
        ['time range', 'time_range'],
        ['dimensions including handle', 'dimensions_including_handle'],
        ['dimensions including handles', 'dimensions_including_handle'],
        ['dimensions with handle', 'dimensions_including_handle'],
        ['dimensions with handles', 'dimensions_including_handle'],
        ['dimensions not including handle', 'dimensions_not_including_handle'],
        ['dimensions not including handles', 'dimensions_not_including_handle'],
        ['dimensions without handle', 'dimensions_not_including_handle'],
        ['dimensions without handles', 'dimensions_not_including_handle'],
        ['weight', 'weight']
      ]);

      const normalizeLabel = (value) =>
        value
          .toLowerCase()
          .replace(/\(\s*[hwdl]\s*[x×]\s*[hwdl]\s*[x×]\s*[hwdl]\s*\)/g, '')
          .replace(/[()]/g, '')
          .replace(/\s+/g, ' ')
          .trim();

      const uniqueValues = (values) => Array.from(new Set(values.filter(Boolean)));

      const readRecentHandles = () => {
        try {
          const storedValue = JSON.parse(window.localStorage.getItem(recentStorageKey) || '[]');
          if (!Array.isArray(storedValue)) return [];
          return storedValue.filter((handle) => typeof handle === 'string' && handle.length > 0);
        } catch (error) {
          return [];
        }
      };

      const readRequestedHandles = () => {
        const parameters = new URLSearchParams(window.location.search);
        const currentHandle = parameters.get('product');
        const selectedHandles = (parameters.get('products') || '')
          .split(',')
          .map((handle) => handle.trim().toLowerCase())
          .filter(Boolean);

        return uniqueValues([
          currentHandle ? currentHandle.trim().toLowerCase() : '',
          ...selectedHandles
        ]);
      };

      const applyInitialSelection = () => {
        const requestedProductIds = readRequestedHandles().map((handle) => productIdsByHandle.get(handle));
        const recentProductIds = readRecentHandles().map((handle) => productIdsByHandle.get(handle));
        const defaultProductIds = selects.map((select) => select.value);
        const availableProductIds = Array.from(templates.keys());
        const initialProductIds = uniqueValues([
          ...requestedProductIds,
          ...recentProductIds,
          ...defaultProductIds,
          ...availableProductIds
        ]).slice(0, selects.length);

        selects.forEach((select, index) => {
          const productId = initialProductIds[index];
          if (!productId) return;
          const matchingOption = Array.from(select.options).some((option) => option.value === productId);
          if (matchingOption) select.value = productId;
        });
      };

      const updateOptionAvailability = () => {
        const selectedProductIds = selects.map((select) => select.value).filter(Boolean);

        selects.forEach((select) => {
          Array.from(select.options).forEach((option) => {
            option.disabled =
              option.value.length > 0 &&
              option.value !== select.value &&
              selectedProductIds.includes(option.value);
          });
        });
      };

      const syncSelectionToUrl = () => {
        const selectedHandles = selects
          .map((select) => productHandlesById.get(select.value))
          .filter(Boolean);

        if (selectedHandles.length === 0) return;

        const destination = new URL(window.location.href);
        destination.searchParams.delete('product');
        destination.searchParams.set('products', selectedHandles.join(','));
        window.history.replaceState({}, '', destination.toString());
      };

      const getValueContainer = (cell) =>
        cell.querySelector('[data-compare-spec-value]') || cell;

      const parseSpecifications = (html) => {
        const documentFromProduct = new DOMParser().parseFromString(html, 'text/html');
        const parsed = {};

        documentFromProduct.querySelectorAll('li').forEach((item) => {
          const text = item.textContent.replace(/\s+/g, ' ').trim();
          const separatorIndex = text.indexOf(':');
          if (separatorIndex < 1) return;

          const label = normalizeLabel(text.slice(0, separatorIndex));
          const key = specificationLabels.get(label);
          const value = text.slice(separatorIndex + 1).trim();
          if (key && value && !parsed[key]) parsed[key] = value;
        });

        return parsed;
      };

      const loadSpecifications = (template) => {
        const productUrl = template.dataset.productUrl;
        if (!productUrl) return Promise.resolve({});
        if (specificationCache.has(productUrl)) return specificationCache.get(productUrl);

        const request = fetch(productUrl, {
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        })
          .then((response) => {
            if (!response.ok) throw new Error(`Product page returned ${response.status}`);
            return response.text();
          })
          .then(parseSpecifications)
          .catch(() => ({}));

        specificationCache.set(productUrl, request);
        return request;
      };

      const setTextValue = (cell, value) => {
        const text = document.createElement('span');
        text.textContent = value;
        getValueContainer(cell).replaceChildren(text);
      };

      const setSmartValue = (cell, isSmart) => {
        const value = document.createElement('span');
        value.className = `cafc__boolean ${isSmart ? 'is-true' : 'is-false'}`;

        if (isSmart) {
          const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          icon.setAttribute('viewBox', '0 0 20 20');
          icon.setAttribute('aria-hidden', 'true');
          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', 'm5 10 3 3 7-7');
          icon.append(path);
          value.append(icon);
        }

        const label = document.createElement('span');
        label.textContent = isSmart ? 'Yes' : 'No';
        value.append(label);
        getValueContainer(cell).replaceChildren(value);
      };

      const hydrateSpecifications = (slotIndex, productId, template) => {
        const title = template.dataset.productTitle || '';
        const smartCell = root.querySelector(
          `[data-compare-spec-slot][data-slot="${slotIndex}"][data-row-id="vesync"]`
        );
        if (smartCell) setSmartValue(smartCell, /\bsmart\b/i.test(title));

        loadSpecifications(template).then((specifications) => {
          if (selects[slotIndex].value !== productId) return;

          Object.entries(specifications).forEach(([key, value]) => {
            const cell = root.querySelector(
              `[data-compare-spec-slot][data-slot="${slotIndex}"][data-row-id="${key}"]`
            );
            if (cell) setTextValue(cell, value);
          });
        });
      };

      const renderSlot = (slotIndex, productId, announce = false) => {
        const cardSlot = root.querySelector(`[data-compare-card-slot][data-slot="${slotIndex}"]`);
        const specificationSlots = root.querySelectorAll(
          `[data-compare-spec-slot][data-slot="${slotIndex}"]`
        );
        const template = templates.get(productId);

        cardSlot.replaceChildren();
        specificationSlots.forEach((cell) => {
          const valueContainer = getValueContainer(cell);
          valueContainer.replaceChildren();
          const emptyValue = document.createElement('span');
          emptyValue.className = 'cafc__empty-value';
          emptyValue.setAttribute('aria-hidden', 'true');
          emptyValue.textContent = '—';
          valueContainer.append(emptyValue);
        });

        if (!template) {
          const placeholder = document.createElement('div');
          placeholder.className = 'cafc__placeholder';
          placeholder.textContent = selects[slotIndex].options[0].textContent;
          cardSlot.append(placeholder);
          return;
        }

        const content = template.content.cloneNode(true);
        const card = content.querySelector('[data-compare-part="card"]');
        cardSlot.append(card);

        specificationSlots.forEach((cell) => {
          const source = content.querySelector(
            `[data-compare-part="spec"][data-row-id="${cell.dataset.rowId}"]`
          );
          if (source) {
            getValueContainer(cell).replaceChildren(...source.cloneNode(true).childNodes);
          }
        });

        hydrateSpecifications(slotIndex, productId, template);

        if (announce && status) {
          status.textContent = selects[slotIndex].selectedOptions[0].textContent;
          window.setTimeout(() => {
            status.textContent = '';
          }, 1800);
        }
      };

      applyInitialSelection();

      selects.forEach((select, index) => {
        renderSlot(index, select.value);
        select.addEventListener('change', () => {
          renderSlot(index, select.value, true);
          updateOptionAvailability();
          syncSelectionToUrl();
        });
      });

      updateOptionAvailability();
      syncSelectionToUrl();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-cosori-compare]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cosori-manuals-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (hub) => {
      if (!hub || hub.dataset.cosoriManualsReady === 'true') return;
      hub.dataset.cosoriManualsReady = 'true';
      const input = hub.querySelector('[data-cosori-manual-query]');
      const cards = [...hub.querySelectorAll('[data-cosori-manual-card]')];
      const filters = [...hub.querySelectorAll('[data-cosori-manual-filter]')];
      const count = hub.querySelector('[data-cosori-manual-count]');
      const empty = hub.querySelector('[data-cosori-manual-empty]');
      const syncManualLinks = hub.dataset.syncManualLinks === 'true';
      let category = 'all';
      const normalize = (value) => value.toLowerCase().normalize('NFKD').replace(/[\s_-]+/g, '');
      // Inspect the selected manual only; never infer languages from the product title,
      // the page's Arabic navigation, the CDN hostname, or URL query parameters.
      const detectManualLanguages = (manualUrl, linkText = '') => {
        const readMarkers = (value) => {
          const languages = [];
          if (/(^|[^a-z])(?:en|english)(?=$|[^a-z])/i.test(value)) languages.push('EN');
          if (/(^|[^a-z])(?:ar|arabic)(?=$|[^a-z])/i.test(value) || /العربية|عربي/.test(value)) languages.push('AR');
          return languages;
        };
        const textLanguages = readMarkers(linkText);
        if (textLanguages.length) return textLanguages;
        let filename = '';
        try {
          filename = new URL(manualUrl, window.location.origin).pathname.split('/').pop() || '';
          try { filename = decodeURIComponent(filename); } catch (_) { /* Keep undecodable names. */ }
        } catch (_) { /* Unmarked links use the English fallback. */ }
        const fileLanguages = readMarkers(filename);
        return fileLanguages.length ? fileLanguages : ['EN'];
      };
      const updateManualLanguages = (card, manualUrl, linkText = '') => {
        const container = card.querySelector('[data-cosori-manual-languages]');
        const separator = card.querySelector('[data-cosori-manual-language-separator]');
        if (!container) return;
        const languages = manualUrl ? detectManualLanguages(manualUrl, linkText) : [];
        container.replaceChildren(...languages.map((language) => {
          const badge = document.createElement('span');
          badge.className = 'cmh-card__language';
          badge.textContent = language;
          return badge;
        }));
        if (separator) separator.hidden = languages.length === 0;
      };
      const findManual = (html, productUrl) => {
        const page = new DOMParser().parseFromString(html, 'text/html');
        const links = [...page.querySelectorAll('a[href]')];
        const manualSection = [...page.querySelectorAll('details, section, article')].find((element) => {
          const heading = element.querySelector('summary, h2, h3, h4');
          return (heading?.textContent || '').trim().toLowerCase().includes('manual');
        });
        const sectionLink = manualSection?.querySelector('a[href]');
        const manualLink = sectionLink || links.find((link) => {
          const text = (link.textContent || '').trim().toLowerCase();
          return text.includes('user manual') || text.includes('download manual');
        }) || links.find((link) => {
          const href = (link.getAttribute('href') || '').toLowerCase();
          const text = (link.textContent || '').trim().toLowerCase();
          const parentText = (link.closest('details, section, article, div')?.textContent || '').toLowerCase();
          return href.includes('.pdf') && (text.includes('manual') || parentText.includes('user manual'));
        });
        if (!manualLink) return null;
        return {
          url: new URL(manualLink.getAttribute('href'), productUrl).href,
          text: (manualLink.textContent || '').trim()
        };
      };
      const activateManualLink = (control, manualUrl) => {
        const link = control.matches('a') ? control : document.createElement('a');
        if (!control.matches('a')) {
          link.className = 'cmh-card__download';
          link.innerHTML = control.innerHTML;
        }
        link.href = manualUrl;
        link.target = '_blank';
        link.rel = 'noopener';
        link.dataset.cosoriManualDownload = '';
        link.dataset.downloadLabel = control.dataset.downloadLabel || '';
        link.dataset.loadingLabel = control.dataset.loadingLabel || '';
        link.dataset.unavailableLabel = control.dataset.unavailableLabel || '';
        link.classList.remove('is-disabled');
        link.removeAttribute('aria-disabled');
        const label = link.querySelector('[data-cosori-manual-label]');
        if (label) label.textContent = control.dataset.downloadLabel;
        if (link !== control) control.replaceWith(link);
      };
      const hydrateManualLinks = async () => {
        await Promise.all(cards.map(async (card) => {
          const control = card.querySelector('[data-cosori-manual-download]');
          const productUrl = card.dataset.productUrl;
          if (!control) return;
          const label = control.querySelector('[data-cosori-manual-label]');
          const fallbackUrl = control.matches('a') ? control.href : '';
          updateManualLanguages(card, fallbackUrl);
          if (!syncManualLinks || !productUrl) return;
          if (!fallbackUrl && label) label.textContent = control.dataset.loadingLabel;
          const absoluteProductUrl = new URL(productUrl, window.location.origin).href;
          try {
            const response = await fetch(absoluteProductUrl, {
              credentials: 'same-origin',
              cache: 'no-store',
              headers: { Accept: 'text/html' }
            });
            if (!response.ok) throw new Error(`Product page returned ${response.status}`);
            const manual = findManual(await response.text(), absoluteProductUrl);
            if (manual) {
              activateManualLink(control, manual.url);
              updateManualLanguages(card, manual.url, manual.text);
            }
            if (!manual && !fallbackUrl && label) label.textContent = control.dataset.unavailableLabel;
          } catch (error) {
            if (!fallbackUrl && label) label.textContent = control.dataset.unavailableLabel;
          }
        }));
      };
      const update = () => {
        const query = normalize(input ? input.value.trim() : '');
        const matched = cards.filter((card) => (category === 'all' || card.dataset.category === category) && (!query || normalize(card.dataset.search).includes(query)));
        cards.forEach((card) => { card.hidden = !matched.includes(card); });
        if (count) count.textContent = String(matched.length);
        if (empty) empty.classList.toggle('is-visible', matched.length === 0);
      };
      filters.forEach((button) => button.addEventListener('click', () => {
        category = button.dataset.cosoriManualFilter;
        filters.forEach((item) => { const active = item === button; item.classList.toggle('is-active', active); item.setAttribute('aria-pressed', String(active)); });
        update();
      }));
      if (input) input.addEventListener('input', update);
      window.addEventListener('resize', update);
      update();
      hydrateManualLinks();
    };
    const initAll = (root = document) => root.querySelectorAll('[data-cosori-manuals]').forEach(init);
    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
